import { HomeOutlined } from '@ant-design/icons';
import { Button, Card, Flex, Typography } from '@contiple/antd-ds';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Flex
      vertical
      gap="16px"
      align="center"
      justify="center"
      style={{ minHeight: '60vh' }}>
      <Card style={{ width: 400, textAlign: 'center' }}>
        <Typography.Title level={2} style={{ color: '#ff4d4f' }}>
          {t('errorPage.notFound.title')}
        </Typography.Title>
        <Typography.Paragraph>
          {t('errorPage.notFound.description')}
        </Typography.Paragraph>
        <Button type="primary" icon={<HomeOutlined />} onClick={handleGoHome}>
          {t('errorPage.notFound.backHome')}
        </Button>
      </Card>
    </Flex>
  );
};

export default NotFound;
